export default "__VITE_ASSET__b50caad2__"